import {
    SESSION,
    SWING,
    SESSION_SUCCESS,
    SWING_SUCCESS,
    SHOW_SESSION_LOADER,
    SHOW_SWING_LOADER,
    HIDE_SESSION_LOADER,
    HIDE_SWING_LOADER,
    VIDEO_DOWNLOAD_AUTH,
    VIDEO_DOWNLOAD_AUTH_SUCCESS,
    SESSION_SELECTED,
    SIGNOUT_DATA,
    UPDATE_PROFILE,
    UPDATE_PROFILE_SUCCESS,
    SHOW_NOTIFICATION_MESSAGE,
    HIDE_NOTIFICATION_MESSAGE,
    SHOW_LOADER,
    HIDE_LOADER,
    REFRESH_SESSION,
    REFRESH_PLAYER
} from '../constants/ActionTypes';

export const sessionFetch = (session) => {
    return {
        type: SESSION,
        payload: session
    };
};
export const swingFetch = (session) => {
    return {
        type: SWING,
        payload: session
    };
};
export const sessionFetchSuccess = (session) => {
    return {
        type: SESSION_SUCCESS,
        payload: session
    };
};
export const swingFetchSuccess = (swing) => {
    return {
        type: SWING_SUCCESS,
        payload: swing
    };
};
export const showSessionLoader = () => {
    return {
        type: SHOW_SESSION_LOADER,
    };
};
export const showSwingLoader = () => {
    return {
        type: SHOW_SWING_LOADER,
    };
};
export const hideSessionLoader = () => {
    return {
        type: HIDE_SESSION_LOADER,
    };
};

export const hideSwingLoader = () => {
    return {
        type: HIDE_SWING_LOADER,
    };
};

export const videoDownloadAuth = (downloadAuth) => {
    return {
        type: VIDEO_DOWNLOAD_AUTH,
        payload: downloadAuth
    };
};

export const videoDownloadAuthSuccess = (downloadAuthJson) => {
    return {
        type: VIDEO_DOWNLOAD_AUTH_SUCCESS,
        payload: downloadAuthJson
    };
};

export const sessionSelected = (sessionObj) => {
    return {
        type: SESSION_SELECTED,
        payload: sessionObj
    };
};

export const signoutData = () => {
    return {
        type: SIGNOUT_DATA,
    };
};

export const updateProfile = (player) => {
    return {
        type: UPDATE_PROFILE,
        payload: player
    }
}

export const updateProfileSuccess = (player) => {
    return {
        type: UPDATE_PROFILE_SUCCESS,
        payload: player
    }
}

export const showNotificationMessage = (message) => {
    console.log("showNotificationMessage")
    return {
        type: SHOW_NOTIFICATION_MESSAGE,
        payload: message
    };
};

export const hideNotificationMessage = (message) => {
    console.log("hideNotificationMessage")
    return {
        type: HIDE_NOTIFICATION_MESSAGE,
        payload: message
    };
};

export const showProfileLoader = () => {
    return {
        type: SHOW_LOADER,
    };
};

export const hideProfileLoader = () => {
    return {
        type: HIDE_LOADER,
    };
};

export const refreshSession = (requestData) => {
    return {
        type: REFRESH_SESSION,
        payload: requestData
    }
}

export const refreshPlayer = (requestData) => {
    return {
        type: REFRESH_PLAYER,
        payload: requestData
    }
}